<template>
	<div v-if="context" class="hidden lg:block">
		<nk-title size="lg">Filtern</nk-title>
		<nk-filter-brancheneintraege-rubriken
			:context="context"
			:options="options"
			class="hidden lg:block"
		/>
	</div>
</template>

<script>
import TemplatesDefault from '#nk/mixins/templates-default';

/**
 * @prop {object} context
 */
export default {
	name: 'NkSidebarFilterBrancheneintraege',

	mixins: [TemplatesDefault],
};
</script>
